<template>
  <v-container>
    <v-layout>
      <v-flex xs6 class="animated fadeIn delay-1s">
        <h5 class="text-uppercase text-xs-left ml-2 mt-3">Gestão de Contatos</h5>
      </v-flex>
    </v-layout>
    <v-layout class="animated fadeIn delay-1s">
      <v-flex xs12>
        <v-card class="pa-3 marginToFooter">
          <v-layout row wrap>
            <v-flex xs12 sm12 md4 lg4>
              <v-select
                v-if="sellers"
                :items="sellers"
                item-text="name"
                v-model="selectedSeller"
                label="Vendedor"
                return-object
                dense
                @change="getContacts()"
                :disabled="loading"
              ></v-select>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm12 md4 lg4 pl-3>
              <v-text-field
                v-model="search"
                append-icon="search"
                label="Buscar"
                single-line
                hide-details
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 md4 lg4 pt-2 class="text-xs-center">
              <v-btn
                small
                depressed
                dark
                round
                color="#099AB1"
                class="text-lowercase"
                @click.stop="confirmarAlteracao = true; action = 'Transferir'"
                :disabled="selected.length <= 0"
              >transferir</v-btn>
              <v-btn
                small
                depressed
                dark
                round
                color="#099AB1"
                class="text-lowercase"
                @click.stop="confirmarAlteracao = true; action = 'Bloquear'"
                :disabled="selected.length <= 0"
              >bloquear</v-btn>
            </v-flex>
          </v-layout>

          <div class="text-xs-center mt-3" v-if="loading">
            <v-progress-circular :size="50" :width="7" color="primary" indeterminate></v-progress-circular>
          </div>

          <v-data-table
            v-if="!loading"
            v-model="selected"
            :headers="headers"
            :items="contatos"
            :search="search"
            select-all
          >
            <template v-slot:items="props">
              <td>
                <v-checkbox color="#099AB1" v-model="props.selected" hide-details></v-checkbox>
              </td>
              <td class="text-xs-left">{{ props.item.situacao }}</td>
              <td class="text-xs-left">{{ props.item.nomeCompleto }}</td>
              <td class="text-xs-left">{{ props.item.quantidadePedidos }}</td>
              <td class="text-xs-left">{{ props.item.dataPrimeiroPedido | formattedDate }}</td>
              <td class="text-xs-left">{{ props.item.dataUltimoPedido | formattedDate }}</td>
              <td class="text-xs-left">{{ props.item.seller }}</td>
              <td class="text-xs-left">{{ props.item.assignedSeller }}</td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
    <v-dialog v-model="confirmarAlteracao" persistent max-width="500">
      <v-card>
        <v-card-title>
          Ação: {{action}}
        </v-card-title>
        <v-card-text v-if="selected.length > 0">
          <div v-if="action == 'Transferir'">
          <p><strong>Vendedor:</strong> {{selected[0].seller}}</p>
          <v-select
                v-if="sellers"
                :items="sellers"
                item-text="name"
                v-model="assignedSeller"
                label="Transferir para"
                return-object
                dense
                required
              ></v-select>
              </div>
          Você confirma a alteraração de <strong>{{selected.length}}</strong> registro(s)?
        </v-card-text>
        <v-card-actions class="animated fadeIn delay-0.5s">
          <v-spacer></v-spacer>
          <v-btn
            round
            small
            outline
            flat="flat"
            class="text-lowercase"
            @click.stop="confirmarAlteracao = false"
          >cancelar</v-btn>

          <v-btn round small dark color="#099AB1" depressed class="text-lowercase" @click="salvarAlteracoes">confirmar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { APIService } from '@/resources/campanha.js';
import format from 'date-fns/format';
import { EventBus } from '@/event-bus.js';

const api = new APIService();

export default {
  data() {
    return {
      assignedSeller: null,
      action: null,
      search: '',
      confirmarAlteracao: false,
      loading: false,
      contatos: [],
      selectedSeller: null,
      selected: [],
      sellers: null,
      customerId: null,
      headers: [
        {
          text: 'Status',
          align: 'left',
          sortable: true,
          value: 'situacao',
        },
        {
          text: 'Nome',
          align: 'left',
          sortable: true,
          value: 'nomeCompleto',
        },
        {
          text: 'Qtd Pedidos',
          align: 'left',
          sortable: true,
          value: 'quantidadePedidos',
        },
        {
          text: 'Primeira Compra',
          align: 'left',
          sortable: true,
          value: 'primeiraCompra',
        },
        {
          text: 'Última Compra',
          align: 'left',
          sortable: true,
          value: 'ultimaCompra',
        },
        {
          text: 'Vendedor',
          align: 'left',
          sortable: true,
          value: 'seller',
        },
        {
          text: 'Transferido para',
          align: 'left',
          sortable: true,
          value: 'assignedSeller',
        },
      ],
    };
  },
  async mounted() {
    await this.getSellers();
  },
  methods: {
    async salvarAlteracoes() {
      if (this.action == 'Bloquear') {
        await api.blockPeople(this.selected);
        this.emitSnackBar();
        this.assignedSeller = null;
        this.confirmarAlteracao = false;
      }
      if (this.action == 'Transferir') {
        await api.transferSeller(this.selected, this.assignedSeller.id);
        await this.$store.dispatch('carregarListaContatos', {
          user: this.$auth.user,
          force: true,
        });
        this.emitSnackBar();
        this.assignedSeller = null;
        this.confirmarAlteracao = false;
      }
    },
    emitSnackBar() {
      const snackBar = {};
      snackBar.text = 'Alteração realizada com sucesso!';
      snackBar.value = true;
      EventBus.$emit('activeSnackBar', snackBar);
    },
    async getContacts() {
      this.loading = true;
      this.contatos = [];
      const data = await api.getResumedCustomer(
        this.customerId,
        this.selectedSeller.name,
      );
      const dataAssigned = await api.getResumedCustomerAssigned(
        this.customerId,
        this.selectedSeller.name,
      );

      this.contatos = data._embedded.persons.concat(dataAssigned._embedded.persons);
      this.contatos.forEach(c => (c.nomeCompleto = `${c.nome} ${c.sobrenome}`));

      this.loading = false;
    },
    async getSellers() {
      const customer = await api.getCustomer(this.$auth.user.sub);
      let myStores = customer.stores;
      if (!this.$store.getters.isDirector) {
        myStores = customer.stores.filter(
          store => store.sellers.filter(seller => seller.id == this.$auth.user.sub)
            .length > 0,
        );
      }

      this.sellers = myStores
        .map(m => m.sellers)
        .reduce((a, b) => a.concat(b), []);
      this.customerId = customer.id;
    },
  },
  filters: {
    formattedDate: item => (item ? format(item, 'DD/MM/YYYY') : 'Não Informado'),
  },
};
</script>

<style scoped>
.v-card {
  box-shadow: none;
  border-radius: 10px;
}

.theme--light.v-sheet {
  border: 1px solid #e0e0e0;
}

.marginToFooter {
  margin-bottom: 75px;
}
</style>
